import * as lodash from 'lodash';
import { DateTime } from 'luxon';

import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';

import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { InputOtpModule } from 'primeng/inputotp';
import { RippleModule } from 'primeng/ripple';

import { NgIconComponent } from '@ng-icons/core';

import { GeneralEditComponent } from '@pages/account/profile/general-edit/general-edit.component';
import { ChangePasswordPage } from '@pages/welcome/change-password/change-password.component';

import { UserStore } from '@cxc/core/services';
import { IdentityAuthAPI } from '@services/API/identity/auth.service';

@Component({
  selector: 'profile-page',
  templateUrl: './profile.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,

    ButtonModule,
    RippleModule,
    InputOtpModule,
    DialogModule,

    NgIconComponent,

    ChangePasswordPage,
    GeneralEditComponent,
  ],
})
export class ProfilePage {
  lodash = lodash;

  constructor(
    public userStore: UserStore,
    private identityAuthAPI: IdentityAuthAPI
  ) {
    toObservable(this.passwordEditDialogVisible).subscribe(visible => {
      if (visible) {
        this.identityAuthAPI
          .forgotPassword({ email: this.userStore.get().email! })
          .subscribe();
      }
    });
  }

  passwordEditDialogVisible = signal(false);
  generalEditDialogVisible = signal(false);

  togglePasswordEditDialog() {
    this.passwordEditDialogVisible.set(!this.passwordEditDialogVisible());
  }

  passwordDialogVisibiliyChanged() {
    this.togglePasswordEditDialog();
  }

  toggleGeneralEditDialog() {
    this.generalEditDialogVisible.set(!this.generalEditDialogVisible());
  }

  generalDialogVisibiliyChanged() {
    this.toggleGeneralEditDialog();
  }

  getBirthdate() {
    return DateTime.fromFormat(
      this.userStore.get().birthdate!,
      'yyyy-MM-dd'
    ).toFormat('dd/MM/yyyy');
  }
}
